// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cPmE","index":"styles_index__eHH8T"};